module.exports = __webpack_public_path__ + "static/start-earning-today-361c7a6fbadddd255bb2320e42a38be2.svg";